export const findFacet = (vendor, facetId, source = '') => {
	if (!vendor.facets) {
		return '';
	}
	const foundFacet = vendor.facets?.find((facet) => facet.id === facetId);
	return foundFacet?.facets?.[0]?.name || '';
};

export const roundReviewRating = (rating) => {
	const parsedNum =
		typeof rating === 'string' ? Number.parseFloat(rating) : rating;

	if (parsedNum === 0 || Number.isNaN(parsedNum)) {
		return 0;
	}
	const roundedNumber = Math.round(parsedNum * 10) / 10;
	return Number.parseFloat(roundedNumber.toFixed(1));
};

export const formatReviewRating = (rating, options = {}) => {
	const { showDecimals = true, preserveZero = true } = options;
	const roundedRating = roundReviewRating(rating);

	if (roundedRating === 0) {
		return showDecimals && preserveZero ? '0.0' : '0';
	}

	if (showDecimals) {
		return roundedRating.toFixed(1);
	}

	return roundedRating % 1 === 0
		? roundedRating.toString()
		: roundedRating.toFixed(1);
};

export const getStarCount = (rating) => {
	return roundReviewRating(rating);
};

export const capacityLimit = (guests) => {
	const range = guests.match(/\d+-(\d+)/);
	return range ? `Up to ${range[1]}` : guests;
};

const bowAndHofMapping = (affiliate) => {
	if (affiliate?.match(/(.*)Best of Weddings/)) {
		const year = affiliate.split(' ')[0];
		return `BOW${year}`;
	}
	if (affiliate?.match(/Hall of Fame/)) {
		return 'BOWHOF';
	}

	return false;
};

export const awardList = (vendor) => {
	const awards = vendor?.affiliates?.[0]?.affiliates || [];
	return awards.map((award) => bowAndHofMapping(award.name)).filter((a) => a);
};

export const address = (vendor) => {
	const addr = vendor?.location?.address;

	return {
		address: addr?.address1 || '',
		city: addr?.city || '',
		state: addr?.state || '',
		postalCode: addr?.postalCode || '',
		isPublic: addr?.isPublic || false,
	};
};
